export const pagesIssuesEn = {
  add: {
    cancelButton: 'Cancel',
    pageTitle: 'Add Issue',
    progressbar: {
      filled: 'Filled',
      modeSetting: 'Input Mode',
      mustItem: 'Required Items',
      mustItemOnly: 'Required fields only',
      progressCircle: 'Progress Circle',
      title: 'Progress',
      total: 'All Items'
    },
    step1: {
      nextButton: 'Next',
      title: 'Basic Information'
    },
    step2: {
      nextButton: 'Next',
      previousButton: 'Back',
      title: 'Issue Content'
    },
    step3: {
      previousButton: 'Back',
      title: 'Occurrence & Detection'
    },
    stepper: {
      basic: 'Basic Information',
      content: 'Issue Content',
      occurrence: 'Occurrence & Detection',
      title: 'Sections'
    },
    submitButton: 'Save',
    validation: {
      required: 'Required'
    }
  },
  addSelect: {
    alternativeConnector: 'Or...',
    csvUploadLabel: 'Bulk upload via CSV',
    detailButton: 'Enter Details',
    externalSyncLabel: 'Sync with External System',
    issueType: {
      requiredItems: 'Required Items',
      title: 'Issue'
    },
    pageTitle: 'Add Issue',
    selectHeading: 'Select what you want to add'
  },
  detail: {
    actions: {
      changeStatus: 'Change Status'
    },
    breadcrumb: {
      backToList: 'Issues'
    },
    changeStatusDialog: {
      cancel: 'Cancel',
      confirm: 'Change Status',
      description: 'Change the status of "{{name}}" from {{currentStatus}} to a new status.',
      required: 'Required',
      success: 'Status has been changed.',
      title: 'Change Status',
      unsavedWarning: 'You have unsaved changes. Changing the status will discard your edits. Continue?',
      unsavedWarningContinue: 'Continue',
      unsavedWarningTitle: 'Unsaved Changes'
    },
    fields: {
      assignees: 'Assignees',
      causeCategory: 'Cause Category',
      causeDetail: 'Cause Detail',
      createdAt: 'Reported At',
      description: 'Description',
      detectedRelease: 'Detected Release',
      detectionPath: 'Detection Method',
      detectionPhase: 'Detection Phase',
      environment: 'Environment',
      externalId: 'External ID',
      externalSystemType: 'External System',
      fixedInRelease: 'Fixed In Release',
      function: 'Function',
      module: 'Module',
      name: 'Title',
      occurrencePhase: 'Occurrence Phase',
      permanentFix: 'Permanent Fix',
      priority: 'Priority',
      product: 'Product',
      recurrencePrevention: 'Recurrence Prevention',
      release: 'Release',
      reopenCount: 'Reopen Count',
      reporter: 'Reporter',
      reproductionProcess: 'Reproduction Steps',
      reviewer: 'Reviewer',
      severity: 'Severity',
      status: 'Status',
      subModule: 'Sub Module',
      targetFixRelease: 'Target Fix Release',
      targetNodes: 'Target Locations',
      updatedAt: 'Updated At'
    },
    history: {
      empty: 'No history yet',
      eventType: {
        CREATED: 'Created',
        STATUS_CHANGED: 'Status changed',
        UPDATED: 'Updated'
      },
      fieldKey: {
        assigneePersonIds: 'Assignees',
        causeCategory: 'Cause category',
        causeDetail: 'Cause detail',
        description: 'Description',
        detectedReleaseId: 'Detected release',
        detectionPathId: 'Detection path',
        detectionPhase: 'Detection phase',
        environmentId: 'Environment',
        externalId: 'External system ID',
        externalSystemType: 'External system type',
        externalUrls: 'External URLs',
        fixedInReleaseId: 'Fixed-in release',
        name: 'Title',
        occurrencePhase: 'Occurrence phase',
        permanentFix: 'Permanent fix',
        priority: 'Priority',
        productNodeIds: 'Occurrence location',
        productionId: 'Production',
        recurrencePrevention: 'Recurrence prevention',
        reproductionProcess: 'Reproduction process',
        reviewerPersonId: 'Reviewer',
        severity: 'Severity',
        status: 'Status',
        targetFixProductionId: 'Target-fix production'
      }
    },
    options: {
      causeCategory: {
        designDefect: 'Design Defect',
        externalDependency: 'External Dependency',
        implementationError: 'Implementation Error',
        operational: 'Operational',
        other: 'Other',
        requirementGap: 'Requirement Gap',
        specChange: 'Spec Change',
        testGap: 'Test Gap'
      },
      externalSystemType: {
        asana: 'Asana',
        backlog: 'Backlog',
        github: 'GitHub',
        jira: 'Jira',
        linear: 'Linear',
        notion: 'Notion',
        other: 'Other',
        slack: 'Slack'
      },
      issuePhase: {
        design: 'Design',
        development: 'Development',
        production: 'Production',
        requirements: 'Requirements',
        review: 'Review',
        staging: 'Staging',
        testing: 'Testing'
      },
      issueSeverity: {
        critical: 'Critical',
        enhanced: 'Enhancement',
        high: 'High',
        low: 'Low',
        medium: 'Medium'
      },
      issueStatus: {
        backlog: 'Backlog',
        dismissed: 'Dismissed',
        in_progress: 'In Progress',
        resolved: 'Resolved',
        untouched: 'Untouched',
        waiting_reproduction: 'Waiting Reproduction'
      },
      priority: {
        high: 'High',
        low: 'Low',
        medium: 'Medium',
        urgent: 'Urgent'
      }
    },
    pageTitle: 'Issue Detail',
    placeholders: {
      assigneeSearch: 'Search assignees...'
    },
    productScope: {
      changeButton: 'Change',
      notLinked: 'No product scope is linked to this issue.',
      selectButton: 'Select',
      toast: {
        success: 'Product scope updated.'
      }
    },
    subSections: {
      assignment: 'Assignment',
      basicIdentification: 'Basic Identification',
      causeAnalysis: 'Cause Analysis',
      occurrenceDetection: 'Occurrence & Detection',
      productStructure: 'Product Structure',
      releaseDelta: 'Release Delta',
      severityPriority: 'Severity & Priority',
      statusProgress: 'Status & Progress'
    },
    tabs: {
      history: 'History',
      productScope: 'Product Scope',
      profile: 'Profile'
    },
    topSections: {
      analysisTeam: 'Analysis & Team',
      basicInfo: 'Basic Information',
      productTest: 'Product & Test'
    }
  },
  externalIntegrations: {
    actions: {
      connect: 'Connect',
      reconnect: 'Reconnect'
    },
    addIntegrationButton: 'Add Integration',
    columns: {
      lastSyncedAt: 'Last Synced',
      software: 'Software',
      syncResult: 'Sync Result',
      syncType: 'Sync Type'
    },
    connectedSystemsHeading: 'Connected External Systems',
    empty: {
      description: 'Use "Add Integration" to connect an external system.',
      title: 'No external systems are connected.'
    },
    lastSyncedSample: 'Nov 17, 2025 12:06',
    pageDescription: 'Asynchronously import and export issue data between external systems.',
    pageTitle: 'External System Integrations',
    relativeTimeSample: '6 months ago',
    syncResult: {
      partialError: 'Partial errors',
      success: 'All succeeded'
    },
    syncType: {
      oneWayImport: 'One-way import'
    }
  },
  list: {
    addIssue: 'Add Issue',
    filterPlaceholder: 'Search issues...',
    filters: {
      product: 'Product',
      severity: 'Severity'
    },
    noResults: 'No matching issues found.',
    pageTitle: 'Issues',
    tabLabel: 'Issue List',
    table: {
      headers: {
        createdAt: 'Reported At',
        name: 'Title',
        severity: 'Severity',
        status: 'Status'
      }
    },
    tabs: {
      all: 'All',
      backlog: 'Backlog',
      dismissed: 'Dismissed',
      inProgress: 'In Progress',
      resolved: 'Resolved',
      untouched: 'Untouched',
      waitingReproduction: 'Waiting Reproduction'
    },
    unassignedProduction: 'Unassigned'
  },
  overview: {
    averageUnresolvedDays: {
      daySuffix: 'd',
      title: 'Avg. Unresolved Days',
      weekOverWeek: 'vs last week'
    },
    countSuffix: '',
    dailyTicketCounts: {
      enhancementLegend: 'Enhancements',
      issueLegend: 'Issues',
      title: 'Daily Ticket Reports'
    },
    enhancementCount: {
      resolved: 'Resolved',
      title: 'Enhancements',
      unresolved: 'Pending'
    },
    issueCount: {
      resolved: 'Resolved',
      title: 'Issues',
      unresolved: 'Unresolved'
    },
    pageTitle: 'Issue Overview',
    severityDistribution: {
      critical: 'Critical',
      high: 'High',
      low: 'Low',
      medium: 'Medium',
      title: 'Severity Distribution'
    }
  },
  title: 'Issues'
};